// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:00:29.616Z
// Property: The Landing at Fiesta Village (ID: 6767906449166438)
// Collections: 28 amenities, 5 floorplans (live), 20 photos, 48 POIs, 2 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166438",
  "property_external_id": "regmy73",
  "property_zillow_url": "https://www.zillow.com/apartments/mesa-az/the-landing-at-fiesta-village/CkJ7M6/",
  "property_apartments_url": "https://www.apartments.com/landing-at-fiesta-village-mesa-az/regmy73/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Landing+at+Fiesta+Village/data=!4m2!3m1!1s0x0:0xfbe29efa7d750758?sa=X&ved=2ahUKEwjqvNzy4qeSAxU2EGIAHVlwKOQQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40264928050",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "912LFV",
  "property_status": null,
  "property_slug": "landing-at-fiesta-village",
  "property_name": "The Landing at Fiesta Village",
  "property_website_url": "https://www.landingfiestavillage.com/",
  "property_domain": "https://www.landingfiestavillage.com/",
  "property_address": "1310 West Southern Avenue",
  "property_full_address": "1310 W Southern Ave, Mesa, AZ 85202",
  "property_address_1": "1310 W Southern Ave",
  "property_address_2": null,
  "property_address_city": "Mesa",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85202",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Central Mesa",
  "property_address_latitude": "33.3942909",
  "property_address_longitude": "-111.8584059",
  "property_email": null,
  "property_phone": "(833) 722-3459",
  "property_call_tracking_phone": "877-907-8988",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Landing at Fiesta Village in Mesa, AZ—a pet-friendly oasis with sleek one, two, and three-bedroom floor plans. Enjoy a smoke-free lifestyle surrounded by resort-style amenities including a heated pool, game room, and 24-hour fitness center. Your ideal home awaits; explore our availability today!",
  "property_long_description": "**Discover Your Ideal Home at Landing at Fiesta Village in Mesa, AZ**\n\nWelcome to Landing at Fiesta Village, where modern living meets unmatched comfort in an inviting, smoke-free community. Our diverse floor plans offer one, two, and three-bedroom apartments designed with thoughtful features to make you feel right at home. Each residence boasts gourmet kitchens with custom cabinetry, granite countertops, and stainless steel appliances, complemented by spacious, open layouts with 9-foot ceilings and wood-style plank flooring.\n\nAt Landing at Fiesta Village, you’ll enjoy an array of amenities tailored for your lifestyle. Dive into relaxation at our stunning heated pool and spa, entertain friends by the outdoor fire pit, or challenge neighbors in our game room. For those needing workspace, our business center with co-working areas provides the perfect environment to stay productive. Plus, you’ll have peace of mind with our gated community, smart door locks, and 24-hour emergency maintenance services.\n\nYour furry friends are welcome here, with a dedicated dog park and pet spa, making it easy for everyone in the family to feel right at home. Additional features include electric vehicle charging stations, parcel pending package lockers, and complimentary common area WiFi for Cox customers.\n\nLocated in the heart of Mesa, AZ, Landing at Fiesta Village offers the perfect blend of luxury and convenience. Don't miss out on your opportunity to live in this vibrant community! Find your new home today – browse our availability or schedule a tour to visit our exceptional amenities and spacious apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f6b9a-8ee4-7502-a064-242497788bbb.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor kitchen area.",
    "public_id": "019f6b9a-8ee4-7502-a064-242497788bbb",
    "storage_key": "property/6767906449166438/019f6b9a-8ee4-7502-a064-242497788bbb.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166438/019ffc3a-0ddd-736f-8cab-e01cb33aa73c.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3a-0ddd-736f-8cab-e01cb33aa73c",
    "storage_key": "property/6767906449166438/019ffc3a-0ddd-736f-8cab-e01cb33aa73c.m4v",
    "thumbnail_key": "property/6767906449166438/019ffc3a-0ddd-736f-8cab-e01cb33aa73c_thumb.webp",
    "size_bytes": 17915808,
    "classification": "Community",
    "title": "Experience Resort-Style Living: Pool, Amenities & More",
    "description": "Discover our vibrant community featuring a sparkling pool, a dog park, and engaging recreational spaces. Tour our modern apartments and enjoy a lifestyle of comfort and convenience."
  },
  "property_total_units": "220",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.9090909090909",
  "property_admin_fee": "350",
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$300-1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "Cats and dogs allowed. No size or weight limit. Breed restrictions apply. Pet deposit: $250. One-time pet fee: $250. Monthly pet rent: $35. Maximum 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://landingatfiestvillage.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amclandingatfiestavillage",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-9224-7630-9e00-821c052a9153.webp",
  "property_primary_logo_media": {
    "alt_text": "The Landing at Fiesta Village logo.",
    "public_id": "019d02cc-9224-7630-9e00-821c052a9153",
    "storage_key": "property/6767906449166438/019d02cc-9224-7630-9e00-821c052a9153.webp",
    "width": 382,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-7d00-7750-893e-b975a369ef29.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02cc-7d00-7750-893e-b975a369ef29",
    "storage_key": "property/6767906449166438/019d02cc-7d00-7750-893e-b975a369ef29.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-9e3a-73fa-bd65-023f78e1c336.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Landing at Fiesta Village logo",
    "public_id": "019d02cc-9e3a-73fa-bd65-023f78e1c336",
    "storage_key": "property/6767906449166438/019d02cc-9e3a-73fa-bd65-023f78e1c336.webp",
    "width": 382,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-9224-7630-9e00-821c052a9153.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Landing at Fiesta Village logo.",
    "public_id": "019d02cc-9224-7630-9e00-821c052a9153",
    "storage_key": "property/6767906449166438/019d02cc-9224-7630-9e00-821c052a9153.webp",
    "width": 382,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "726 - 1278",
  "property_sqft_min": "726",
  "property_sqft_max": "1278",
  "property_price_range": "$1349 - $2113",
  "property_price_min": "1349",
  "property_price_max": "2113",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/thelanding85202/",
  "property_instagram_url": "https://www.instagram.com/thelanding85202/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJfYWgqhMHK4cRWAd1ffqe4vs",
  "property_youtube_url": "https://www.youtube.com/watch?t=527&v=Kg1x-z3mRxg",
  "property_yelp_url": "https://www.yelp.com/biz/fiesta-village-mesa-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Landing at Fiesta Village",
  "property_home_romance_title": "Embrace the Comfort of Your New Apartment Oasis",
  "property_home_amenities_blurb": "Welcome to Landing at Fiesta Village in Mesa, AZ, where modern living meets comfort. Unwind by the stunning heated pool, enjoy movie nights in the clubhouse, or pamper your furry friends in our pet spa. With stylish apartments and unmatched amenities, your new home is waiting just for you!",
  "property_home_floorplans_blurb": "Welcome to Landing at Fiesta Village in sunny Mesa, AZ, where comfort meets style. Each thoughtfully designed floor plan caters to your lifestyle, offering modern amenities and spacious living. Browse our available apartment homes to find the perfect layout that suits your needs and elevates your living experience.",
  "property_home_gallery_blurb": "Experience the vibrant lifestyle at Landing at Fiesta Village in Mesa, AZ. Choose from one, two, or three-bedroom floor plans featuring gourmet kitchens and private balconies. Unwind in our stunning heated pool, enjoy the game room, or connect in our coworking space. Picture yourself living here, where comfort meets luxury!",
  "property_home_neighborhood_blurb": "At Landing at Fiesta Village in Mesa, AZ, vibrant living meets convenience. Choose from one, two, or three-bedroom floor plans and immerse yourself in a wealth of nearby attractions. From Arizona State University to the Arizona Museum of Natural History, enjoy the perfect blend of culture and adventure just outside your door.",
  "property_home_reviews_blurb": "At Landing at Fiesta Village in Mesa, AZ, residents rave about the vibrant community atmosphere, stating, “The friendly neighbors and well-maintained grounds make this place feel like home.” Experience the welcoming spirit that awaits you—see what our residents have to say about living in this exceptional community!",
  "property_neighborhood_blurb": "At Landing at Fiesta Village in Mesa, AZ, adventure awaits just beyond your doorstep. Immerse yourself in culture at Arizona Museum of Natural History, study at Hayden Library, or unwind at Tempe Beach Park. With vibrant local favorites and scenic escapes nearby, your ideal lifestyle starts here. Explore the neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Landing at Fiesta Village in Mesa, AZ, where luxury meets comfort. Enjoy our stunning heated pool, vibrant resident clubhouse, and a community dog park—all within a secure, smoke-free environment. Each apartment boasts gourmet kitchens and spacious layouts, perfect for a lifestyle that celebrates relaxation and convenience.",
  "property_applynow_blurb": "Elevate your living experience at Landing at Fiesta Village in Mesa, AZ. Choose from one, two, or three-bedroom floor plans, each featuring gourmet kitchens and spacious layouts. Enjoy upscale amenities like a stunning heated pool, resident clubhouse, and pet-friendly dog park. Your dream home awaits—lease online today!",
  "property_contactus_blurb": "At Landing at Fiesta Village in Mesa, AZ, your ideal home awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to every lifestyle. Want to learn more? Our friendly leasing team is here to assist with all your questions—reach out today!",
  "property_faqs_blurb": "At Landing at Fiesta Village in Mesa, AZ, we offer a range of thoughtfully designed floor plans—one, two, and three bedrooms—catering to diverse lifestyles. Have questions about our vibrant community? Our FAQs page is your go-to resource for insights and answers to help you make the best choice!",
  "property_floorplans_blurb": "At Landing at Fiesta Village in sunny Mesa, AZ, your ideal home awaits! With spacious one, two, and three-bedroom floor plans designed for comfort and style, you'll find the perfect space to suit your lifestyle. Browse our available apartment homes to discover a community tailored just for you.",
  "property_gallery_blurb": "At Landing at Fiesta Village in Mesa, AZ, your dream lifestyle awaits. Imagine lounging by our stunning heated pool, entertaining in the outdoor area, or unwinding in our resident clubhouse. With spacious floor plans and top-notch amenities, picture yourself living in a vibrant, pet-friendly community tailored for relaxation and enjoyment!",
  "property_interactivemap_blurb": "Welcome to Landing at Fiesta Village in Mesa, AZ, where spacious living meets exceptional amenities. From our stunning heated pool to the vibrant resident clubhouse, every detail invites connection and relaxation. Uncover your ideal one, two, or three-bedroom apartment with modern finishes and smart technology, all within a pet-friendly haven.",
  "property_pets_blurb": "At Landing at Fiesta Village in Mesa, AZ, your furry friends are family! Enjoy pet-friendly living with a generous policy that welcomes up to two pets per apartment. With no size or weight limits, your four-legged companions can truly feel at home in our vibrant community.",
  "property_referafriend_blurb": "At Landing at Fiesta Village in Mesa, AZ, cozy up in one of our thoughtfully designed one, two, or three-bedroom apartments. Great friends make great neighbors—invite someone special to enjoy our vibrant community today! They’ll thank you, and so will we! ",
  "property_residentaccess_blurb": "Welcome to Landing at Fiesta Village in vibrant Mesa, AZ! Our spacious one-, two-, and three-bedroom floor plans cater to your lifestyle. For current residents, access the portal to effortlessly manage rent payments, schedule maintenance, and enjoy seamless community living. Your comfort and convenience are just a click away!",
  "property_reviews_blurb": "At Landing at Fiesta Village in Mesa, AZ, residents cherish the vibrant community atmosphere. One happy tenant shares, \"The friendly staff and beautiful surroundings make everyday living a pleasure!\" Ready to feel the same? Dive into the heartfelt reviews from our residents and see what makes us stand out!",
  "property_created_at": "1759782564997",
  "property_scheduletour_blurb": "At Landing at Fiesta Village in Mesa, AZ, find the perfect home tailored to your lifestyle. Choose from spacious one, two, or three-bedroom floor plans designed for comfort and convenience. Schedule a tour today and see why our residents love calling this vibrant community home! 💖",
  "property_thankyou_blurb": "Thank you for reaching out to Landing at Fiesta Village in sunny Mesa, AZ! Your journey to finding the perfect one, two, or three-bedroom apartment starts now. Our team will connect with you shortly to help you discover your ideal home in our vibrant community. Stay tuned!",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at Landing at Fiesta Village in Mesa, AZ, where our thoughtfully designed one, two, and three-bedroom apartments redefine comfort. Immerse yourself in our community’s charm—take a virtual tour today and envision your new home surrounded by exceptional amenities and inviting spaces.",
  "property_copyright": "2025 All Rights Reserved. Landing at Fiesta Village",
  "property_seo_title_home": "Apartments in Mesa, AZ | Landing at Fiesta Village",
  "property_seo_description_home": "Landing at Fiesta Village is a luxury apartment living Community with pet-friendly 1, 2 & 3-Bedroom apts for rent in Mesa, AZ. Contact us today!",
  "property_seo_title_floorplans": "Floor Plans | Luxury 1, 2 & 3-Bedroom Apts in Mesa, AZ",
  "property_seo_description_floorplans": "Explore 1, 2 & 3-Bedroom apts at Landing at Fiesta Village in Mesa. A state-of-the-art gym, a business center with co-working spaces, and a clubhouse await.",
  "property_seo_title_amenities": "Amenities | Mesa Apartments With a Heated Swimming Pool",
  "property_seo_description_amenities": "Enjoy a heated swimming pool and poolside cabanas at Landing at Fiesta Village in Mesa, AZ. Pet-friendly living made easy.",
  "property_seo_title_gallery": "Gallery | Luxury Apartments For Rent in Mesa, AZ",
  "property_seo_description_gallery": "View photos of Landing at Fiesta Village in Mesa, AZ. See stylish floor plans, luxury amenities, and pet-friendly community spaces.",
  "property_seo_title_virtualtours": "Virtual Tour | Luxury Pet-Friendly Apartments in Mesa, AZ",
  "property_seo_description_virtualtours": "Embark on a virtual journey at Landing at Fiesta Village! Explore our pet-friendly 1, 2 & 3-Bedroom apts in Mesa, AZ, through our virtual tours.",
  "property_seo_title_interactivemap": "Interactive Map | Landing at Fiesta Village Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Landing at Fiesta Village in Mesa, AZ! Check our interactive map for floor plans, pricing, and amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Luxury Apartments Near Fiesta Sports Complex",
  "property_seo_description_neighborhood": "Live close to Arizona State University and Kleinman Park at Landing at Fiesta Village with luxury apartments designed for your comfort and convenience.",
  "property_seo_title_contact": "Contact Us | Apartments Near Arizona State University",
  "property_seo_description_contact": "Contact Landing at Fiesta Village today to schedule a tour. Discover 1, 2 & 3-Bedroom apts with modern features in Mesa near Fiesta Sports Complex..",
  "property_seo_title_faqs": "FAQs | Apartments in Mesa, AZ",
  "property_seo_description_faqs": "Find answers to your questions about Landing at Fiesta Village in Mesa, AZ. Explore our unique amenities, floor plans, and pet-friendly living in style!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mesa, AZ",
  "property_seo_description_reviews": "Experience life at Landing at Fiesta Village in Mesa, AZ! Check out genuine resident reviews and see why our smoke-free community feels like home.",
  "property_seo_title_applynow": "Apply Now | 2 Bedroom Apartments in Mesa, AZ",
  "property_seo_description_applynow": "Ready to make Landing at Fiesta Village your new home? Apply online for our 1, 2 & 3-Bedroom apts in Mesa and start your journey today!",
  "property_seo_title_residentaccess": "Resident Access | Luxury One Bedroom Units",
  "property_seo_description_residentaccess": "At Landing at Fiesta Village, our resident portal offers seamless 24/7 access, simplifying maintenance requests and online rent payments for your convenience.",
  "property_seo_title_referafriend": "Refer A Friend | Landing at Fiesta Village",
  "property_seo_description_referafriend": "Refer a friend to Landing at Fiesta Village in Mesa, AZ! Great friends make great neighbors—share our vibrant community and enjoy the perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments Near Kleinman Park",
  "property_seo_description_scheduletour": "Excited to explore Landing at Fiesta Village in person? Arrange a tour to discover our amenities and open-concept apartment designs in Mesa, AZ!",
  "property_seo_title_privacy": "Privacy Policy | Landing at Fiesta Village",
  "property_seo_description_privacy": "At Landing at Fiesta Village in Mesa, AZ, your privacy matters. Stay informed about how we protect your information. Check out our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Landing at Fiesta Village",
  "property_seo_description_accessibility": "Embrace comfort and convenience at Landing at Fiesta Village in Mesa, AZ. Our accessibility statement reflects our commitment to inclusive living for all.",
  "property_seo_title_sitemap": "Sitemap | Landing at Fiesta Village",
  "property_seo_description_sitemap": "Navigate your way to comfort at Landing at Fiesta Village in Mesa, AZ. Check out our sitemap for easy access to amenities, floor plans, and more!",
  "property_seo_title_thankyou": "Thank You | Lease Landing at Fiesta Village Apartments in AZ",
  "property_seo_description_thankyou": "Thank you for your interest in Landing at Fiesta Village Apartments. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pets | Pet-Friendly Apartments in Mesa, AZ",
  "property_seo_description_pets": "At Landing at Fiesta Village in Mesa, AZ, your furry friends are family! Enjoy pet-friendly living with a generous policy that welcomes up to two pets per apartment. With no size or weight limits, your four-legged companions can truly feel at home in our vibrant community.",
  "property_updated_at": "1786643094342",
  "amenities": [
    {
      "id": "custom_f277cd79-99d7-4242-9dce-7da99ef88179",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke-Free",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_8aa41ea5-6b71-41e2-ba11-168edb142c5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Stunning Heated Pool & Spa with Poolside Cabanas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_dcac2080-0077-45c4-9c17-2e62de2a6574",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community with Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d219da38-b990-4d64-8d93-1799f60b6cb3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse with Lounge Areas, TVs, Coffee Bar, Billiards and More",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_93754691-5aeb-41db-bcd9-58754ec526e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Community Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fb57fc66-e5f1-4925-a005-cef7e47343fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_660ea606-cf31-40c1-86bf-1cfbea849c98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center with Coworking Space",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f5e0d13d-32dd-49cb-9ab3-5050993f8f0e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Entertainment Area with Lounge Seating, Fire Pit and Grilling Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fffe4ab6-d9a6-48f6-be03-db4abb6531e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center with State-of-the-Art Equipment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_45600f98-4146-4a24-a28d-90e19f5399db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Common Area WiFi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_648fad10-54cf-41a5-8c48-c47f3ac1a977",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Community Dog Park & Pet Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_671e718f-ec36-4dff-88f8-25bbacc48281",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2c546b4e-109b-4bcf-93e1-ded356e15701",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Parcel Pending Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_337de272-aa78-42df-b49f-d221a6cb1eaf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7d340dc6-784f-4fba-84f5-24e0a10bee84",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Professional & Responsive Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_dc633bdc-1fd8-426c-8ac1-02e08a131f72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Door Locks, Thermostats & Lights; All Easily Controlled with the MyAPT App by Cox",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a6a5cf88-ce56-43b5-bf21-4e300b108cb3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_00b7c5de-ef98-4a0c-8d7b-8311dad6564f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchen with Custom Cabinetry, Granite Countertops & Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_bf84c1f4-9cfb-4b92-b322-a1c7eb60d6c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Full Sized In-Unit Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d3e647f4-ce2d-4707-bb9c-580bd169888f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Style Plank Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2fa61c2a-0b3d-4988-a8c5-560521f1e069",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1d5fca68-2aaa-4973-bfe2-2331aca51b72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive 9-Foot Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c35f52fb-3f71-495d-8781-2ce856cb2361",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Private Main Bedrooms with En Suite Bathroom*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fad662a7-7ee3-46f5-a9a2-06365058b525",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Ceiling Fans in Living Areas & Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_90baf35e-b92a-43be-98a2-e4e5c2305ab2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets with Built-In Shelving & Storage*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c34938d6-9c7c-45b9-a3ac-796f03cab936",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Dual Vanity Sinks*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e3e9d658-14d6-4f20-974f-29d0b313bed7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available for Rent",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_07a08924-e77c-417e-be2f-a9dd12a2b7ba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_876c138b-0d4d-4859-9bcf-a3b080820fc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-d4cf-72e3-b6e0-e8be2866071c.webp",
      "image_media": {
        "alt_text": "Modern community lounge with seating and wall art at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-d4cf-72e3-b6e0-e8be2866071c",
        "storage_key": "property/6767906449166438/01a01086-d4cf-72e3-b6e0-e8be2866071c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stylish community lounge featuring comfortable seating, a decorative ceiling, and large windows with views of the outdoors. \"Party Celebrate Gather\" is written on the wall.",
      "link": "",
      "alt_text": "Modern community lounge with seating and wall art at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b7995cc5-b83b-41f6-acdf-197b93f95584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-8782-7607-b0b8-b2da5926112a.webp",
      "image_media": {
        "alt_text": "Modern lounge area with large windows, comfortable seating, and a coffee bar at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-8782-7607-b0b8-b2da5926112a",
        "storage_key": "property/6767906449166438/01a01086-8782-7607-b0b8-b2da5926112a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a well-appointed coffee bar and ample seating for socializing or quiet reflection. Enjoy the natural light and vibrant atmosphere.",
      "link": "",
      "alt_text": "Modern lounge area with large windows, comfortable seating, and a coffee bar at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_714b1977-14ff-48b5-9939-afd18c10b554",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-9163-768c-8b7a-87d0a99309ee.webp",
      "image_media": {
        "alt_text": "Modern leasing office with a welcome display, communal seating areas, and views of the outdoors at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-9163-768c-8b7a-87d0a99309ee",
        "storage_key": "property/6767906449166438/01a01086-9163-768c-8b7a-87d0a99309ee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office, featuring stylish communal workspaces and a vibrant \"Welcome\" display, creating a modern and inviting atmosphere for prospective residents.",
      "link": "",
      "alt_text": "Modern leasing office with a welcome display, communal seating areas, and views of the outdoors at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_62cd592b-1e91-403d-a0a2-c52a547cc94f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f66a3-7fbd-7477-ba62-7dcaf5a73d17.webp",
      "image_media": {
        "alt_text": "Community coffee bar with a large table, green chairs, and a TV mounted on a coffee-themed wall at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "019f66a3-7fbd-7477-ba62-7dcaf5a73d17",
        "storage_key": "property/6767906449166438/019f66a3-7fbd-7477-ba62-7dcaf5a73d17.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee at the community coffee bar, featuring a large communal table and modern decor. Perfect for a quick pick-me-up or casual meetings.",
      "link": "",
      "alt_text": "Community coffee bar with a large table, green chairs, and a TV mounted on a coffee-themed wall at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5cb2240a/dms3rep/multi/5742705921490944/6767906449166438/bf67e86eb8aa801fd92a44ee36a5efa0.jpg"
    },
    {
      "id": "custom_e28daa12-d800-4280-a81a-dae1295745b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-9693-75cc-910a-b1e01bfcc724.webp",
      "image_media": {
        "alt_text": "Community lounge with shuffleboard table, pool table, and dartboard at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-9693-75cc-910a-b1e01bfcc724",
        "storage_key": "property/6767906449166438/01a01086-9693-75cc-910a-b1e01bfcc724.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy fun and games in our community lounge, complete with shuffleboard, pool, and darts.",
      "link": "",
      "alt_text": "Community lounge with shuffleboard table, pool table, and dartboard at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce3ac572-405e-4153-a736-0b312f0a0e5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-be35-7729-b1ad-de81a43e6ed0.webp",
      "image_media": {
        "alt_text": "Modern conference room with a large table, executive chairs, and a flat-screen TV.",
        "public_id": "01a01086-be35-7729-b1ad-de81a43e6ed0",
        "storage_key": "property/6767906449166438/01a01086-be35-7729-b1ad-de81a43e6ed0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Host your next meeting in our stylish conference room, complete with comfortable seating and the latest technology for productive sessions.",
      "link": "",
      "alt_text": "Modern conference room with a large table, executive chairs, and a flat-screen TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f671821c-9ecc-4f9f-8daf-fd0c3a4effa7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f66a3-8bde-70f8-bb42-b28bbdde84fa.webp",
      "image_media": {
        "alt_text": "Modern gym with weights, cardio machines, and a punching bag at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "019f66a3-8bde-70f8-bb42-b28bbdde84fa",
        "storage_key": "property/6767906449166438/019f66a3-8bde-70f8-bb42-b28bbdde84fa.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a full range of strength training equipment, cardio machines, and a dedicated area for boxing and functional training.",
      "link": "",
      "alt_text": "Modern gym with weights, cardio machines, and a punching bag at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5cb2240a/dms3rep/multi/5742705921490944/6767906449166438/407f53754842fca1809983dd8ed1b1ee.jpg"
    },
    {
      "id": "custom_ce2686d9-8297-41c2-af76-4bdfdac9aa7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-f649-74d6-89d8-5b5951414f9c.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weightlifting equipment, and punching bag at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-f649-74d6-89d8-5b5951414f9c",
        "storage_key": "property/6767906449166438/01a01086-f649-74d6-89d8-5b5951414f9c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines, weightlifting stations, and a dedicated area for functional training.",
      "link": "",
      "alt_text": "Modern gym with cardio machines, weightlifting equipment, and punching bag at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42ca7ca8-01c8-4fd8-a895-37d3e88ee315",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-bf93-70a8-b4a0-3da6b668478d.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex courtyard with a sparkling swimming pool, lounge chairs, umbrellas, and an outdoor dining area.",
        "public_id": "01a01086-bf93-70a8-b4a0-3da6b668478d",
        "storage_key": "property/6767906449166438/01a01086-bf93-70a8-b4a0-3da6b668478d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style living at our community, featuring a beautiful swimming pool, comfortable lounge areas, and an outdoor dining space perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex courtyard with a sparkling swimming pool, lounge chairs, umbrellas, and an outdoor dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bcef4c9c-b86a-4932-8ec9-8e0b0a36ec4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-f2de-70b7-8007-8ea26bcde7d9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a modern apartment complex at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-f2de-70b7-8007-8ea26bcde7d9",
        "storage_key": "property/6767906449166438/01a01086-f2de-70b7-8007-8ea26bcde7d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a modern apartment complex at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40f571dd-977f-46d5-bfb3-e5951b9e7a15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-9f49-702c-8cf6-3f969900ccf8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and covered seating.",
        "public_id": "01a01086-9f49-702c-8cf6-3f969900ccf8",
        "storage_key": "property/6767906449166438/01a01086-9f49-702c-8cf6-3f969900ccf8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool or relax in the soothing hot tub. Lounge chairs and covered seating areas are available for your comfort.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and covered seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bba05ee8-29e4-4329-a5f0-f822327ca337",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01087-1116-76af-84bb-490f6f3cde53.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with a fire pit, lounge chairs, and a swimming pool in front of apartment buildings at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01087-1116-76af-84bb-490f6f3cde53",
        "storage_key": "property/6767906449166438/01a01087-1116-76af-84bb-490f6f3cde53.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy relaxation and social gatherings in our community's outdoor lounge area, featuring a cozy fire pit, comfortable seating, and a refreshing swimming pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with a fire pit, lounge chairs, and a swimming pool in front of apartment buildings at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0159037f-a7d2-40a0-abfd-cfad853b17fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-94e0-7298-8df4-09e5e4756b43.webp",
      "image_media": {
        "alt_text": "Children's playground and outdoor picnic area with grills.",
        "public_id": "01a01086-94e0-7298-8df4-09e5e4756b43",
        "storage_key": "property/6767906449166438/01a01086-94e0-7298-8df4-09e5e4756b43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a playground, picnic tables, and barbecue grills for residents.",
      "link": "",
      "alt_text": "Children's playground and outdoor picnic area with grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fa8ed4c3-54aa-4d8f-818f-69780b5508a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-b59b-73ab-ab4b-84dbf4dbc0bb.webp",
      "image_media": {
        "alt_text": "Outdoor entertainment area with a grill, bar seating, and cornhole games at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-b59b-73ab-ab4b-84dbf4dbc0bb",
        "storage_key": "property/6767906449166438/01a01086-b59b-73ab-ab4b-84dbf4dbc0bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a built-in grill, bar, and recreational games in this vibrant community space.",
      "link": "",
      "alt_text": "Outdoor entertainment area with a grill, bar seating, and cornhole games at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a27b47b7-0982-4784-9f8d-42b7dd82e41e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-5fae-7363-a593-47f39e38e6a5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-5fae-7363-a593-47f39e38e6a5",
        "storage_key": "property/6767906449166438/01a01086-5fae-7363-a593-47f39e38e6a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a large island, premium stainless steel appliances, and ample cabinet space. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05a5e331-7b0c-4b3e-832f-dac1d94adccf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-c587-7389-a7cc-abe1b6fd1645.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island and table at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-c587-7389-a7cc-abe1b6fd1645",
        "storage_key": "property/6767906449166438/01a01086-c587-7389-a7cc-abe1b6fd1645.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully designed kitchen featuring dark wood cabinets, granite countertops, and stainless steel appliances, flowing into a dining area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with island and table at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6594dba6-68ee-4ab1-baf8-5d7e35a754ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-4410-77ea-bfad-702d58cf0381.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and TV at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-4410-77ea-bfad-702d58cf0381",
        "storage_key": "property/6767906449166438/01a01086-4410-77ea-bfad-702d58cf0381.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy stylish living in this modern apartment's living room, featuring comfortable seating and entertainment space.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and TV at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45c569a7-f5e3-4cbb-b318-0d82587a5500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f66a3-a3f0-773c-93a1-1606487c8e8b.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa and artwork at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "019f66a3-a3f0-773c-93a1-1606487c8e8b",
        "storage_key": "property/6767906449166438/019f66a3-a3f0-773c-93a1-1606487c8e8b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sectional sofa, modern coffee table, and abstract art. Open-concept layout flows into a well-equipped kitchen.",
      "link": "",
      "alt_text": "Living room with sectional sofa and artwork at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5cb2240a/dms3rep/multi/5742705921490944/6767906449166438/fc9c15a69a9ab7ab50cae4368ad5eacb.jpg"
    },
    {
      "id": "custom_5e0a0955-b65a-433d-b1e1-207f376af465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-6014-758d-91e5-30297d10dd0a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-6014-758d-91e5-30297d10dd0a",
        "storage_key": "property/6767906449166438/01a01086-6014-758d-91e5-30297d10dd0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant nightstand, modern dresser, and a convenient ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d92144a0-4d66-490b-9807-c162372cc5f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/01a01086-906d-7665-b86a-d9c94884eeca.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop vanity, white sink, and glass-enclosed shower at Landing at Fiesta Village in Mesa, AZ.",
        "public_id": "01a01086-906d-7665-b86a-d9c94884eeca",
        "storage_key": "property/6767906449166438/01a01086-906d-7665-b86a-d9c94884eeca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury in this stylish apartment bathroom, featuring a sleek granite vanity, a spacious walk-in shower, and elegant finishes.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop vanity, white sink, and glass-enclosed shower at Landing at Fiesta Village in Mesa, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_01077ee4-6c48-4550-8984-33b745da118e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Main Event Tempe",
      "poi_type": "Entertainment",
      "poi_address": "8545 S Emerald Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "Chain featuring arcade games, Bowling and Laser Tag, as well as a rope-walking attraction.",
      "poi_long_description": "People say this restaurant offers a variety of activities, including bowling, laser tag, and arcade games. They also highlight the fun atmosphere and the friendly, helpful staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-460f-70f0-97e3-f23a844dbbf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-460f-70f0-97e3-f23a844dbbf0",
        "storage_key": "property/6767906449166438/019d02cc-460f-70f0-97e3-f23a844dbbf0.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/arizona/tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=3811411622178510185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-event-tempe",
      "poi_latitude": "33.337249",
      "poi_longitude": "-111.9674006",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-753-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89bd-fc1e214c8da9",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJscW22MwFK4cRadW-OK3a5DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e28b5b60-5fd5-4dfe-b689-6f336bebb4ba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "AMC Mesa Grand 14",
      "poi_type": "Entertainment",
      "poi_address": "1645 S Stapley Dr, Mesa, AZ 85204, USA",
      "poi_short_description": "Chain movie theater featuring IMAX, Dolby Cinema, and plush, reclining seats.",
      "poi_long_description": "Moviegoers say this movie theater offers comfortable reclining seats, a great Dolby Digital experience, and a wide selection of snacks, including popcorn. They also highlight the friendly and helpful staff, the clean facilities, and the convenient features like free refills and online ordering.\n\nSome reviews mention the concession prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-4694-755c-9153-6e43b0e0de3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-4694-755c-9153-6e43b0e0de3e",
        "storage_key": "property/6767906449166438/019d02cc-4694-755c-9153-6e43b0e0de3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/phoenix/amc-mesa-grand-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11496104796945459597&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-mesa-grand-14",
      "poi_latitude": "33.384176",
      "poi_longitude": "-111.8020733",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-503-1680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-6762-710d-a150-5c094b7c88d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-6762-710d-a150-5c094b7c88d8",
        "storage_key": "property/6767906449166438/019d02cc-6762-710d-a150-5c094b7c88d8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJlaU0nfOoK4cRjSmZYmdeip8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0e4b7a4c-3f85-4aa0-b86d-6d2eb128baaa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "K1 Speed Phoenix",
      "poi_type": "Entertainment",
      "poi_address": "2501 E Magnolia St, Phoenix, AZ 85034, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "People say this amusement center offers fast go-karts, a fun track, and an arcade with games. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the thrilling atmosphere.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-4614-72be-8e1d-12fef4a77d72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-4614-72be-8e1d-12fef4a77d72",
        "storage_key": "property/6767906449166438/019d02cc-4614-72be-8e1d-12fef4a77d72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://k1speed.com/phoenix-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16366161456476043528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "k1-speed-phoenix",
      "poi_latitude": "33.4218087",
      "poi_longitude": "-112.0284479",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-275-5278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVamTvTwOK4cRCLnxDSJJIOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_7a80e18c-c4c2-4479-8e40-e466d535af66",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Skateland",
      "poi_type": "Entertainment",
      "poi_address": "7 E Southern Ave, Mesa, AZ 85210, USA",
      "poi_short_description": "High-energy spot for roller skaters ages 5 & up, with a snack bar, arcade, special events & more.",
      "poi_long_description": "People say this roller skating rink offers a fun, retro vibe with great music and lights, and is a popular spot for birthday parties. They also highlight the friendly staff, clean rink, and well-maintained skates.\n\nOther reviews mention the food options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-45f4-76ca-a9e9-ce6a5b0b905a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-45f4-76ca-a9e9-ce6a5b0b905a",
        "storage_key": "property/6767906449166438/019d02cc-45f4-76ca-a9e9-ce6a5b0b905a.webp",
        "width": 1179,
        "height": 638
      },
      "poi_business_url": "https://www.unitedskates.com/skateland-mesa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10039581733811081639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "skateland",
      "poi_latitude": "33.392564",
      "poi_longitude": "-111.830821",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-833-7775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVo3eXKoK4cRp1FPGWXCU4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_72e01bdc-595d-42ac-b8b7-dcc94c9b67ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 E Rio Salado Pkwy, Tempe, AZ 85288, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-4a60-74c2-9a23-7b0146bb70e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-4a60-74c2-9a23-7b0146bb70e7",
        "storage_key": "property/6767906449166438/019d02cc-4a60-74c2-9a23-7b0146bb70e7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10422522416146546925&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "33.43002440000001",
      "poi_longitude": "-111.9069773",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-966-3647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b49d-71f5-9d91-4747e6c078a3",
        "storage_key": "property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsUxzIDIIK4cR7QD2peo8pJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_494f9034-7d0e-4cef-adf8-5adc07d8973d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Food City",
      "poi_type": "Shopping & Retail",
      "poi_address": "822 S Alma School Rd, Mesa, AZ 85210, USA",
      "poi_short_description": "Casual chain selling Latin American groceries (including produce, roasted chicken), plus meat and a deli counter.",
      "poi_long_description": "People say this grocery store offers fresh produce, a deli with homemade food, and a bakery with pan dulce and tres leches cakes. They also highlight the reasonable prices and friendly staff.\n\nOther reviews mention the self-checkout experience can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-4b21-7324-a9b6-0b07261728f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-4b21-7324-a9b6-0b07261728f7",
        "storage_key": "property/6767906449166438/019d02cc-4b21-7324-a9b6-0b07261728f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myfoodcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3652788643014330743&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "food-city",
      "poi_latitude": "33.3996598",
      "poi_longitude": "-111.8586553",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-827-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89be-0188a8d1b346.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89be-0188a8d1b346",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89be-0188a8d1b346.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8edpHwAIK4cRd0lz4upPsTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_984767b4-9d5d-425e-859f-0adf2709f813",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "1951 W Baseline Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Neighborhood retailer trading in bakery items and produce as well as butcher-shop staples and a pharmacy.",
      "poi_long_description": "People say this grocery store offers a great selection of fresh produce, deli items, and baked goods. They also highlight the clean and well-organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-4ac3-7486-b1e7-b305d7297ea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-4ac3-7486-b1e7-b305d7297ea0",
        "storage_key": "property/6767906449166438/019d02cc-4ac3-7486-b1e7-b305d7297ea0.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.albertsons.com/az/mesa/1951-w-baseline-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11978051112511150459&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "33.3773824",
      "poi_longitude": "-111.8761598",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-456-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89be-0188a8d1b346.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89be-0188a8d1b346",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89be-0188a8d1b346.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvdd8gFinK4cRexmzPgaWOqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4d978b42-51d4-4f27-86c7-1070f2fbcd54",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1230 S Longmore, Mesa, AZ 85202, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of products. They also highlight the convenient location, clean environment, and friendly staff.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-4d9e-732f-adad-d92501d73d85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-4d9e-732f-adad-d92501d73d85",
        "storage_key": "property/6767906449166438/019d02cc-4d9e-732f-adad-d92501d73d85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/mesa-west/1429",
      "poi_directions_map_url": "https://maps.google.com/?cid=5145491257275651377&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.3916851",
      "poi_longitude": "-111.8652426",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-281-0105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b49d-71f5-9d91-4747e6c078a3",
        "storage_key": "property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpbzeCPwHK4cRMRXLWAl1aEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_344ce65e-e426-4011-8e28-83ed71ba5479",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Whiskey Wednesdays Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1457 W Southern Ave Unit A1, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this sports bar serves up delicious cheese curds and elotes, and they praise the friendly staff and lively atmosphere, especially during karaoke nights. They also highlight the great service, reasonable prices, and wide selection of drinks, including whiskey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-5195-70e6-ab0f-d432c39e5441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5195-70e6-ab0f-d432c39e5441",
        "storage_key": "property/6767906449166438/019d02cc-5195-70e6-ab0f-d432c39e5441.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.whiskeywednesdaysaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7261522751390049216&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whiskey-wednesdays-bar--grill",
      "poi_latitude": "33.3925021",
      "poi_longitude": "-111.8621684",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-471-6553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-690b-744f-8786-d19e6ea7dbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-690b-744f-8786-d19e6ea7dbd2",
        "storage_key": "property/6767906449166438/019d02cc-690b-744f-8786-d19e6ea7dbd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyTXd8MHK4cRwGMFHXgcxmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_c89b37cb-c7f0-44da-b852-2d96bd10ded3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1434 S Alma School Rd, Mesa, AZ 85210, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "People say this steakhouse serves perfectly cooked steaks, tasty ribs, and decent lobster. They also highlight the friendly staff, fast service, and good value.\n\nSome reviews mention the food can be overseasoned.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-51e4-77aa-995d-b8d0622617c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-51e4-77aa-995d-b8d0622617c5",
        "storage_key": "property/6767906449166438/019d02cc-51e4-77aa-995d-b8d0622617c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/az/mesa/mesa-fiesta-mall/5448?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:mesa-az-5448_pl:locurl_rd:1387",
      "poi_directions_map_url": "https://maps.google.com/?cid=13304502533631140111&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.38845",
      "poi_longitude": "-111.85782",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-461-0790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89bd-fc1e214c8da9",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqWtcGvgHK4cRD2FeZpAWo7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a2b6b042-0897-42ba-b483-4c2270dfa90c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Oregano's",
      "poi_type": "Restaurants",
      "poi_address": "1130 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Family-friendly Italian chain specializing in Chicago-style pizzas & sandwiches.",
      "poi_long_description": "People say this Italian restaurant serves delicious pizza, pasta, and salads, with generous portions. They also highlight the friendly and attentive service, and the fun, old-school vibe.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-514e-707a-8b99-79abf64864f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-514e-707a-8b99-79abf64864f4",
        "storage_key": "property/6767906449166438/019d02cc-514e-707a-8b99-79abf64864f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oreganos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15220184483985335138&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oreganos",
      "poi_latitude": "33.3939461",
      "poi_longitude": "-111.8750243",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-962-0036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89bd-fc1e214c8da9",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTIai-EHK4cRYqPb7yX1ONM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_24332988-e882-450e-a9e0-527147dc5f13",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1261 W Southern Ave, Mesa, AZ 85202, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves delicious breadsticks, lasagna, and chicken gnocchi soup. They also highlight the friendly and attentive staff, quick service, and great prices.\n\nSome reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-5404-719f-8cdc-2fbd24d03ba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5404-719f-8cdc-2fbd24d03ba4",
        "storage_key": "property/6767906449166438/019d02cc-5404-719f-8cdc-2fbd24d03ba4.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/az/mesa/southern-fiesta-mall-west-mesa-alma-school-rd/1661?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:mesa-az-1661_pl:locurl_rd:1516",
      "poi_directions_map_url": "https://maps.google.com/?cid=13483034279168141953&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "33.392567",
      "poi_longitude": "-111.859038",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-964-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89bd-fc1e214c8da9",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5zbl0fgHK4cRgWo7oD1cHbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_47f9105e-0e2a-46e2-ba8c-8fa36831aca9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Señor Sushi Mesa",
      "poi_type": "Restaurants",
      "poi_address": "1356 W Southern Ave, Mesa, AZ 85202, USA",
      "poi_short_description": "Spacious, family friendly place for Mexican-Japanese fusion fare in an informal setting.",
      "poi_long_description": "People say this Asian fusion restaurant offers delicious sushi rolls, firecracker jalapenos, and carne asada rolls, as well as tasty drinks like the skinny margarita. They also highlight the generous portions, reasonable prices, and welcoming atmosphere.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02cc-56ae-72c7-aae4-a877c3b3e8c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-56ae-72c7-aae4-a877c3b3e8c8",
        "storage_key": "property/6767906449166438/019d02cc-56ae-72c7-aae4-a877c3b3e8c8.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.senorsushimesa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14295543318106715681&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "seor-sushi-mesa",
      "poi_latitude": "33.3935213",
      "poi_longitude": "-111.8618424",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-629-4731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89bd-fc1e214c8da9",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ZbWvv4HK4cRIbb1Iuj4Y8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "custom_dfabd3f6-ac12-4b8c-9f2f-a7317859c793",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Arizona Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 S Arizona Mills Cir, Tempe, AZ 85282, USA",
      "poi_short_description": "Lively mall featuring an aquarium, a cinema, a food court, a Lego center and many big-box stores.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including outlets, and attractions like an aquarium, arcade, and movie theater. They also highlight the good deals, spacious layout, and family-friendly atmosphere with a carousel and train ride.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-75fd-7624-bc28-9a9fc75d7dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-75fd-7624-bc28-9a9fc75d7dc0",
        "storage_key": "property/6767906449166438/019d02ca-75fd-7624-bc28-9a9fc75d7dc0.webp",
        "width": 700,
        "height": 467
      },
      "poi_business_url": "https://www.simon.com/mall/arizona-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=2145774981481083229&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-mills",
      "poi_latitude": "33.383125",
      "poi_longitude": "-111.964485",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-491-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b49d-71f5-9d91-4747e6c078a3",
        "storage_key": "property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh_lm4VkPK4cRXbEZE_pSxx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a64f1450-ce74-40e1-b55a-14954b12c51c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Tempe Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 E Rio Salado Pkwy, Tempe, AZ 85288, USA",
      "poi_short_description": "Outdoor complex featuring shops for clothing, electronics, and home goods. It also features eateries and a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, restaurants, and entertainment options, including a movie theater, live music, and a splash pad. They highlight the fun and lively atmosphere, with frequent events and live music, and the convenient location near the Salt River with a beautiful trail. They also like the clean and well-maintained facilities, with misters to keep cool during hot weather.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-77b2-750f-9107-9b1e4e713915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-77b2-750f-9107-9b1e4e713915",
        "storage_key": "property/6767906449166438/019d02ca-77b2-750f-9107-9b1e4e713915.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tempemarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16874235038211004953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-marketplace",
      "poi_latitude": "33.4340695",
      "poi_longitude": "-111.9012791",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-966-9338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b49d-71f5-9d91-4747e6c078a3",
        "storage_key": "property/6767906449166438/019d02ca-b49d-71f5-9d91-4747e6c078a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz3KubQsJK4cRGVoEHV1TLeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e404c1d6-37cd-4f1b-8eb3-8ae4f925c659",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Mesa Community College",
      "poi_type": "Education",
      "poi_address": "1833 W Southern Ave, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-7e0e-7641-887e-8a5e54f03941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-7e0e-7641-887e-8a5e54f03941",
        "storage_key": "property/6767906449166438/019d02ca-7e0e-7641-887e-8a5e54f03941.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6768540005639575714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mesa-community-college",
      "poi_latitude": "33.3895475",
      "poi_longitude": "-111.8735409",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-461-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b499-730b-9c19-83309c622915",
        "storage_key": "property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh1-MyeQHK4cRotgqHEav7l0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a7c2d811-3e5b-4c21-aedf-1c3406d4cff3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Tempe Public Library",
      "poi_type": "Education",
      "poi_address": "3500 S Rural Rd, Tempe, AZ 85282, USA",
      "poi_short_description": "Public library offering books and media for checkout, plus a cafe and programs.",
      "poi_long_description": "People say this public library offers a wide selection of literature. They highlight the open and friendly vibe. They also like the helpful and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-8445-72e9-99d8-00397b9c4e47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8445-72e9-99d8-00397b9c4e47",
        "storage_key": "property/6767906449166438/019d02ca-8445-72e9-99d8-00397b9c4e47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tempepubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13306252390981778904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-public-library",
      "poi_latitude": "33.39131450000001",
      "poi_longitude": "-111.9280626",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-350-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b499-730b-9c19-83309c622915",
        "storage_key": "property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR35tTZ8IK4cR2D0p0AxOqbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_cfcbc99d-e673-4cde-8a2e-74482ab6f7ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "155 W Hampton Ave, Mesa, AZ 85210, USA",
      "poi_short_description": "Family-friendly complex offering mini-golf and go-karts plus a wave pool and slides.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, go-karts, bumper boats, laser tag, and a water park with slides, a lazy river, and a wave pool. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the reasonable prices for mini golf.\n\nOther reviews mention the facilities can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-8a3c-709e-abbc-884501fe78cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8a3c-709e-abbc-884501fe78cd",
        "storage_key": "property/6767906449166438/019d02ca-8a3c-709e-abbc-884501fe78cd.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.golfland.com/mesa",
      "poi_directions_map_url": "https://maps.google.com/?cid=7202226290688624874&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golfland-sunsplash",
      "poi_latitude": "33.3880994",
      "poi_longitude": "-111.8372277",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-834-8319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZWRoxOoK4cR6oh5AKdy82M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_47cabc2e-94d4-48bf-811b-3202df01fa09",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1661 S Alma School Rd, Mesa, AZ 85210, USA",
      "poi_short_description": "Well-equipped fitness club featuring free weights, treadmills and group classes, plus basketball courts.",
      "poi_long_description": "Visitors say this gym has a wide variety of well-maintained equipment, a sauna, and clean showers. They also highlight the friendly and helpful staff, and the affordable membership fees.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-8e70-74f9-9408-d203a9e86246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8e70-74f9-9408-d203a9e86246",
        "storage_key": "property/6767906449166438/019d02ca-8e70-74f9-9408-d203a9e86246.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/mesa-alma-school-us-60/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13470119672115952446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.3845959",
      "poi_longitude": "-111.8557407",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-210-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSF1lB2oK4cRPvt4Wnl677o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_42a18c72-8f47-429b-b42f-b2d4631d2950",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Mountainside Fitness Tempe Marina Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Rio Salado Pkwy #102, Tempe, AZ 85281, USA",
      "poi_short_description": "Chain, featuring state-of-the-art exercise equipment, plus views of Tempe Town Lake and the Salt River.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-912d-7739-8f64-40a400b13da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-912d-7739-8f64-40a400b13da7",
        "storage_key": "property/6767906449166438/019d02ca-912d-7739-8f64-40a400b13da7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/tempe-marina-heights/?utm_source=GMB&utm_medium=Local&utm_campaign=Tempe&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9270648553778270050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-tempe-marina-heights",
      "poi_latitude": "33.4310649",
      "poi_longitude": "-111.9336089",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-664-6209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3Re0SYJK4cRYk9x3b31p4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d3994c17-d86f-456e-977f-3dad550c595e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 N Alma School Rd, Chandler, AZ 85224, USA",
      "poi_short_description": "Bright athletic club that’s part of a chain offering workout equipment, pools, group classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of machines, free weights, and fitness classes, as well as amenities like a sauna, steam room, and massage chairs. They also highlight the friendly, welcoming, and helpful staff, and the clean and well-maintained facilities.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-90de-7681-8292-5cae131ef6d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-90de-7681-8292-5cae131ef6d0",
        "storage_key": "property/6767906449166438/019d02ca-90de-7681-8292-5cae131ef6d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/az/chandler-az/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2576456338315450084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.32258100000001",
      "poi_longitude": "-111.860333",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-603-0814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoecIIRQHK4cR5JaYmGNpwSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a3175222-5c6a-4db9-a1f3-19196f39cafa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "63 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Clean gym offering classes, weights and cardiovascular equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and a basketball court, as well as amenities like a pool and sauna. They also highlight the spacious layout, clean facilities, and friendly, helpful staff.\n\nOther reviews mention the gym can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-9656-75fd-8190-971725ae6d29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9656-75fd-8190-971725ae6d29",
        "storage_key": "property/6767906449166438/019d02ca-9656-75fd-8190-971725ae6d29.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=38&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14282970337445433486&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.3916509",
      "poi_longitude": "-111.9381288",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-829-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdgTFaUIK4cRjlDg9NhNN8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3e22713c-85e7-40a8-8291-b420eaecb86d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Banner Desert Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-9654-7418-b29b-6afe7157d81a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9654-7418-b29b-6afe7157d81a",
        "storage_key": "property/6767906449166438/019d02ca-9654-7418-b29b-6afe7157d81a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/mesa/banner-desert-medical-center?y_source=1_MTE5MDczNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=614197494924193389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-desert-medical-center",
      "poi_latitude": "33.3908762",
      "poi_longitude": "-111.8771772",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-412-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-be0a-700a-a0b5-c2f7c53e4b73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-be0a-700a-a0b5-c2f7c53e4b73",
        "storage_key": "property/6767906449166438/019d02ca-be0a-700a-a0b5-c2f7c53e4b73.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1qJLOEHK4cRbS7kEl4Rhgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_65b53093-6ced-423e-986e-9dec9ec7b794",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Banner Children's at Desert",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-978c-7069-94e1-4709bca9a462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-978c-7069-94e1-4709bca9a462",
        "storage_key": "property/6767906449166438/019d02ca-978c-7069-94e1-4709bca9a462.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/mesa/banner-childrens-at-desert?y_source=1_MTE5MDczMjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3958880602645632281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-childrens-at-desert",
      "poi_latitude": "33.3899517",
      "poi_longitude": "-111.8773528",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-412-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-be0a-700a-a0b5-c2f7c53e4b73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-be0a-700a-a0b5-c2f7c53e4b73",
        "storage_key": "property/6767906449166438/019d02ca-be0a-700a-a0b5-c2f7c53e4b73.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1qJLOEHK4cRGZXg3O7E8DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4bac0af6-04f8-44b8-a97f-b5f4e4fcab73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Freestone District Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1045 E Juniper Ave, Gilbert, AZ 85234, USA",
      "poi_short_description": "Park offering a skate park and a train ride, plus playgrounds, tennis courts and basketball courts.",
      "poi_long_description": "Visitors say this park offers a variety of activities, including playgrounds, walking trails, sports courts, batting cages, a skate park, and a small amusement park with rides and concessions. They also highlight the park's scenic beauty, with its well-maintained grounds, peaceful ponds, and abundant ducks and birds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-9b81-761f-a00b-bfe46e849489.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9b81-761f-a00b-bfe46e849489",
        "storage_key": "property/6767906449166438/019d02ca-9b81-761f-a00b-bfe46e849489.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gilbertaz.gov/departments/parks-and-recreation/parks-information/parks/freestone-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12042390189943833304&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freestone-district-park",
      "poi_latitude": "33.3590953",
      "poi_longitude": "-111.7685207",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 480-503-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-be01-7450-8663-466fd7ef1bd7",
        "storage_key": "property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cy8OTOpK4cR2EJADhMqH6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a1e6f0c6-8893-4acb-9ad3-5b9344302b48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Dobson Ranch Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2155 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Golf course with a driving range, outdoor games, and Bluetooth speakers in carts.",
      "poi_long_description": "People say this golf course offers a fun and challenging course, a great driving range with screens that track ball distance, and a practice facility. They highlight the good value, especially for residents, and the chill, laid-back atmosphere with country music. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-9ca7-7323-b751-1e1ac3bd5e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9ca7-7323-b751-1e1ac3bd5e98",
        "storage_key": "property/6767906449166438/019d02ca-9ca7-7323-b751-1e1ac3bd5e98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://dobsonranchgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=321594549685786380&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dobson-ranch-golf-course",
      "poi_latitude": "33.3749492",
      "poi_longitude": "-111.8782925",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-644-2291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-bece-777a-a849-b2cf4637126b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-bece-777a-a849-b2cf4637126b",
        "storage_key": "property/6767906449166438/019d02ca-bece-777a-a849-b2cf4637126b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJNywLqJMHK4cRDBe5_4mIdgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d1c14b5b-18ba-457c-b88c-cec562447927",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Riverview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2100 W Rio Salado Pkwy, Mesa, AZ 85201, USA",
      "poi_short_description": "Park offering playgrounds, picnic tables and a zip line, plus a splash area.",
      "poi_long_description": "People say this park offers a splash pad, climbing structures, a zip line, and a lake for fishing and duck feeding. They highlight the park is clean, well-maintained, and fun for all ages, with plenty of shaded picnic tables and walking trails. They also like the beautiful views and peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-9df9-714b-820b-2029d0720d40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9df9-714b-820b-2029d0720d40",
        "storage_key": "property/6767906449166438/019d02ca-9df9-714b-820b-2029d0720d40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesaparks.com/parks-facilities/parks/riverview-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17087911469867597812&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverview-park",
      "poi_latitude": "33.4322497",
      "poi_longitude": "-111.8744021",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-644-2352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-be01-7450-8663-466fd7ef1bd7",
        "storage_key": "property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2VpIazQIK4cR9P_HOvJ0JO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_65e074a1-f15a-4ad4-9568-ed5c4bc74f75",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Grass Clippings Rolling Hills",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1415 N Mill Ave, Tempe, AZ 85288, USA",
      "poi_short_description": "Casual, public, 18-hole venue for golf featuring lit fairways for evening play.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a04d-77ff-99d4-5620791e7948.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a04d-77ff-99d4-5620791e7948",
        "storage_key": "property/6767906449166438/019d02ca-a04d-77ff-99d4-5620791e7948.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://grassclippingsaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16919195564819074998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grass-clippings-rolling-hills",
      "poi_latitude": "33.4449783",
      "poi_longitude": "-111.9481945",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-530-9880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-bece-777a-a849-b2cf4637126b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-bece-777a-a849-b2cf4637126b",
        "storage_key": "property/6767906449166438/019d02ca-bece-777a-a849-b2cf4637126b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7VQlDUJK4cRts9ndrkOzeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_51916776-cd68-4c1a-8ce2-cdf8cdbeceb3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Veterans Way/College Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a2cc-7569-8c1a-d202a16f81bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a2cc-7569-8c1a-d202a16f81bb",
        "storage_key": "property/6767906449166438/019d02ca-a2cc-7569-8c1a-d202a16f81bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4598022879801229784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterans-waycollege-ave",
      "poi_latitude": "33.426067",
      "poi_longitude": "-111.935959",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30kcm9gIK4cR2MGro3J1zz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_16907910-5bb5-41c6-9c2a-045bc3cc2154",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Gilbert Rd. / Main St.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mesa, AZ 85204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a2d2-7237-bcf3-61a8ccafa01e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a2d2-7237-bcf3-61a8ccafa01e",
        "storage_key": "property/6767906449166438/019d02ca-a2d2-7237-bcf3-61a8ccafa01e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13494624434564559224&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gilbert-rd--main-st",
      "poi_latitude": "33.41533",
      "poi_longitude": "-111.790758",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wnmTiGmK4cRePGG92yJRrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_df94d0a4-a90e-49ee-910d-9294b09129d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Mill Ave/3rd St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a4c7-7385-8d96-6fc62c9477b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a4c7-7385-8d96-6fc62c9477b2",
        "storage_key": "property/6767906449166438/019d02ca-a4c7-7385-8d96-6fc62c9477b2.webp",
        "width": 1013,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=639866828117951134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-ave3rd-st",
      "poi_latitude": "33.427453",
      "poi_longitude": "-111.9406986",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPes7bCgJK4cRnsKGcX1D4Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_90b9937f-dc68-41b5-82ab-85d3d8d00760",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Dorsey Ln/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a699-7540-b813-523543ee707f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a699-7540-b813-523543ee707f",
        "storage_key": "property/6767906449166438/019d02ca-a699-7540-b813-523543ee707f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13215672625481361333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dorsey-lnapache-blvd",
      "poi_latitude": "33.414769",
      "poi_longitude": "-111.916907",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3tuBO4IK4cRtaertTuAZ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2aef218a-feb8-48b0-9c70-9f13fdc533f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "McClintock/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a879-724e-9830-ffc20626f7a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a879-724e-9830-ffc20626f7a2",
        "storage_key": "property/6767906449166438/019d02ca-a879-724e-9830-ffc20626f7a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13252773368337084250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcclintockapache-blvd",
      "poi_latitude": "33.4147381",
      "poi_longitude": "-111.9082666",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV59aPvQIK4cRWi99jClP67c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_462159cb-b02b-4883-a4ee-d24de47cb44e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "State Farm at Marina Heights",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 E Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-a8bb-711f-a1a0-bce21e6baf0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a8bb-711f-a1a0-bce21e6baf0e",
        "storage_key": "property/6767906449166438/019d02ca-a8bb-711f-a1a0-bce21e6baf0e.webp",
        "width": 1280,
        "height": 1049
      },
      "poi_business_url": "https://www.statefarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601884207670731235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-farm-at-marina-heights",
      "poi_latitude": "33.4299472",
      "poi_longitude": "-111.9305218",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-733-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_x42CAJK4cR46GFITMJOxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_01ea05b2-6447-46df-8212-3596714e15c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Amazon AZA3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1665 W Alameda Dr #101, Tempe, AZ 85282, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-aa45-7458-b442-89aa7466f485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-aa45-7458-b442-89aa7466f485",
        "storage_key": "property/6767906449166438/019d02ca-aa45-7458-b442-89aa7466f485.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10427779108402156537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-aza3",
      "poi_latitude": "33.3982292",
      "poi_longitude": "-111.9650968",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJa0zIPK4cR-dOMsNnptpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b2d56496-b665-4c1d-b905-18350048978a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Amazon AZA10",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8600 S Science Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-ae9d-716b-89a6-74d5316388cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae9d-716b-89a6-74d5316388cb",
        "storage_key": "property/6767906449166438/019d02ca-ae9d-716b-89a6-74d5316388cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17057723990554394837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-aza10",
      "poi_latitude": "33.3383978",
      "poi_longitude": "-111.8970169",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZTAyQQHK4cR1UCn_Zc1uew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bedebedd-3e32-4782-bb75-834f0d409003",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Roosevelt Elementary School",
      "poi_type": "Education",
      "poi_address": "828 S Valencia, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-1b47-70ed-826e-813374ff22fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-1b47-70ed-826e-813374ff22fb",
        "storage_key": "property/6767906449166438/019efacb-1b47-70ed-826e-813374ff22fb.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://roosevelt.mpsaz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1131037702724895031&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roosevelt-elementary-school",
      "poi_latitude": "33.3995206",
      "poi_longitude": "-111.8815299",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-472-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b499-730b-9c19-83309c622915",
        "storage_key": "property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45sdq3QIK4cRN8F9UsxAsg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_29b45e72-0901-47be-a248-4f32cb829af8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Rhodes Junior High School",
      "poi_type": "Education",
      "poi_address": "1860 S Longmore Ste a, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-13e1-763e-ad17-fa29b189df6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-13e1-763e-ad17-fa29b189df6c",
        "storage_key": "property/6767906449166438/019efacb-13e1-763e-ad17-fa29b189df6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mpsaz.org/rhodes",
      "poi_directions_map_url": "https://maps.google.com/?cid=15282639921700113535&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rhodes-junior-high-school",
      "poi_latitude": "33.3807378",
      "poi_longitude": "-111.8694319",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-472-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b499-730b-9c19-83309c622915",
        "storage_key": "property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV23s2O0HK4cRf4wjswnYFtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3d7b35bc-08b6-4c0a-bf0d-220b3bd610be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Dobson Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2359 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Urban park featuring an ample all–abilities play area with a zip line & jumbo musical instruments.",
      "poi_long_description": "People say this park offers diverse play areas for children of all ages, including a swing zip line, and features a beautiful lake with walking paths and opportunities for fishing. Visitors also highlight the clean and peaceful atmosphere, along with ample shady spots and benches. They also appreciate the convenient location next to a library and the dog-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-1a7a-7333-8dce-138b8e435cab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-1a7a-7333-8dce-138b8e435cab",
        "storage_key": "property/6767906449166438/019efacb-1a7a-7333-8dce-138b8e435cab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mesaparks.com/parks-facilities/parks/dobson-ranch-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14607894604521279640&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dobson-ranch-park",
      "poi_latitude": "33.3716937",
      "poi_longitude": "-111.8793894",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-be01-7450-8663-466fd7ef1bd7",
        "storage_key": "property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe68P5UHK4cRmBDWMr-quco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d82e9fd1-e561-4c2a-ad91-00141ef4e06f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Mill Ave. and, S All America Way, Tempe, AZ 85283, USA",
      "poi_short_description": "Park with a lake & a 54,000-sq.-ft. complex with an indoor wave pool & a 15-court tennis center.",
      "poi_long_description": "People say this park offers a lake with walking trails, a playground, a splash pad, and picnic areas. They highlight the park is clean, well-maintained, and family-friendly, with plenty of space for various activities. They also like the convenient parking and the upcoming dog park. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-13cd-716a-a51f-3ba4d9c7ee15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-13cd-716a-a51f-3ba4d9c7ee15",
        "storage_key": "property/6767906449166438/019efacb-13cd-716a-a51f-3ba4d9c7ee15.webp",
        "width": 979,
        "height": 680
      },
      "poi_business_url": "https://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/120/3542?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13961563785378829176&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "33.3718923",
      "poi_longitude": "-111.9391798",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-be01-7450-8663-466fd7ef1bd7",
        "storage_key": "property/6767906449166438/019d02ca-be01-7450-8663-466fd7ef1bd7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6LURxAGK4cReJN2kEpwwcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bc7fe049-a432-4c06-8919-9545068ce514",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Sycamore/Main St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-15dc-76bb-985f-20b6b9f621c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-15dc-76bb-985f-20b6b9f621c4",
        "storage_key": "property/6767906449166438/019efacb-15dc-76bb-985f-20b6b9f621c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11164844096949134175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sycamoremain-st",
      "poi_latitude": "33.41486",
      "poi_longitude": "-111.87091",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3CIpxcIK4cRXyNFY41-8Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_9b9a7ff0-3bdd-472b-8890-c64f2ff6784d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Valley Metro Route 61 (Southern Ave)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Southern Ave & Alma School Rd, Mesa, AZ 85202",
      "poi_short_description": "Valley Metro local bus route along Southern Avenue, with the nearest stop directly at the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0938632b-5a28-4d13-b66d-30108731fe6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "The Boeing Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 E McDowell Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-1683-75e1-a14a-1637a322336a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-1683-75e1-a14a-1637a322336a",
        "storage_key": "property/6767906449166438/019efacb-1683-75e1-a14a-1637a322336a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15131330919155889974&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-boeing-company",
      "poi_latitude": "33.4710189",
      "poi_longitude": "-111.7191463",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-891-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeuKM06kK4cRNvcrP01J_dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_4dcbeda2-48c6-40fa-b9b7-67fa5afaf40c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Mesa City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20 E Main St, Mesa, AZ 85201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-13ed-7627-9836-99ed905074af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-13ed-7627-9836-99ed905074af",
        "storage_key": "property/6767906449166438/019efacb-13ed-7627-9836-99ed905074af.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.mesaaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10457448983489772213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mesa-city-hall",
      "poi_latitude": "33.4156027",
      "poi_longitude": "-111.830782",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b8e8-741b-b99e-b0b33276933f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b8e8-741b-b99e-b0b33276933f",
        "storage_key": "property/6767906449166438/019d02ca-b8e8-741b-b99e-b0b33276933f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7c1wcKnK4cRtXqtzXFSIJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_93ec95e8-f1ae-41e6-abf3-b8259f022665",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Salt River Project",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 N Mill Ave, Tempe, AZ 85288, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019efacb-1874-7352-ba6f-b1d9673b676a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efacb-1874-7352-ba6f-b1d9673b676a",
        "storage_key": "property/6767906449166438/019efacb-1874-7352-ba6f-b1d9673b676a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.srpnet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884516187771630722&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "salt-river-project",
      "poi_latitude": "33.446293",
      "poi_longitude": "-111.9511442",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-236-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b937-777b-8972-fa1f0c9ec832",
        "storage_key": "property/6767906449166438/019d02ca-b937-777b-8972-fa1f0c9ec832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_V1UEA0OK4cRgvTZb7eQMvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_6412983f-61ea-4943-a7af-6c9b96d80dfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Dobson High School",
      "poi_type": "Education",
      "poi_address": "1501 W Guadalupe Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f0524-7526-7200-9d07-958898c3a1e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0524-7526-7200-9d07-958898c3a1e4",
        "storage_key": "property/6767906449166438/019f0524-7526-7200-9d07-958898c3a1e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dobson.mpsaz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6305897694383346257&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dobson-high-school",
      "poi_latitude": "33.3624727",
      "poi_longitude": "-111.8678905",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-472-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b499-730b-9c19-83309c622915",
        "storage_key": "property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMQqvJYUHK4cRUZKs_4oMg1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b5b4880c-9446-4f71-bfbb-c00a82b41f5f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Beautiful Oasis Childcare",
      "poi_type": "Education",
      "poi_address": "1010 W Southern Ave, Mesa, AZ 85210, USA",
      "poi_short_description": "Preschool that offers a curriculum for kids aged six weeks to 12 years. There’s also inside and outside play areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f0524-76c9-740e-9791-ec4071630f6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0524-76c9-740e-9791-ec4071630f6c",
        "storage_key": "property/6767906449166438/019f0524-76c9-740e-9791-ec4071630f6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.beautifuloasischildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12757754296005061657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "beautiful-oasis-childcare",
      "poi_latitude": "33.3939688",
      "poi_longitude": "-111.8535023",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-461-1638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b499-730b-9c19-83309c622915",
        "storage_key": "property/6767906449166438/019d02ca-b499-730b-9c19-83309c622915.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQYmq1wOoK4cRGWwYUfClDLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_61f3eab6-42cb-4f58-8934-aca8ca89ac26",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "poi_name": "Native Grill & Wings",
      "poi_type": "Restaurants",
      "poi_address": "1837 W Guadalupe Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Casual restaurant serving wings in various flavors plus an extensive menu of American comfort fare.",
      "poi_long_description": "People say this chicken wings restaurant serves great pizza and wings. They also highlight the attentive and easy-going service, and the numerous TVs for watching sports.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f0524-77d3-757a-8f29-e552b56ce149.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0524-77d3-757a-8f29-e552b56ce149",
        "storage_key": "property/6767906449166438/019f0524-77d3-757a-8f29-e552b56ce149.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.nativegrillandwings.com/ll/US/AZ/Mesa/1837-West-Guadalupe*-Suite-122",
      "poi_directions_map_url": "https://maps.google.com/?cid=12477399915781222553&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "native-grill--wings",
      "poi_latitude": "33.363683",
      "poi_longitude": "-111.873659",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-456-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b4a3-7671-89bd-fc1e214c8da9",
        "storage_key": "property/6767906449166438/019d02ca-b4a3-7671-89bd-fc1e214c8da9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSKqoJAHK4cRmfCghB2hKK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    }
  ],
  "office_hours": [
    {
      "id": "ec_48ce12cca9e1e528ba775ff7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8831f158d09f4116ce10bad2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bd541940f5023871eaffc473",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6246053ec53dd5960712b9f0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_99a97036d134a0815da0d58c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_05a3858fa01b00464c3ad556",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e4b08808-004f-4f4c-a89a-a0b284bd9ee5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "rating": "5.0",
      "name": "KEVIN FRANCIS",
      "text": "I met with Morgan Manning today (THE LANDING Leasing Consultant). Morgan was so kind, courteous, knowledgeable and attentive to my needs. The property looks amazingly well kept. I walked a two bedroom/two bath unit. This is one of the best properties in the surrounding areas. In addition to their unbelievable leasing specials, the units are priced in a way that won’t break your bank. If you’re looking for peace, comfort, affordability and tranquility, please consider THE LANDING.",
      "date": "2025-08-05",
      "title": ""
    },
    {
      "id": "custom_0b8c0226-5068-4804-befa-d670d2a9295d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "rating": "5.0",
      "name": "Yasmine O",
      "text": "Honestly if you are new to the city, or a college student this is a great place to have your first apartment! They bring the community together with Holiday events! All together they are a great apartment complex and great management team!",
      "date": "2025-04-18",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bf7a8317-96a8-470c-ab91-59e287fdb94f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f6c18-5c60-773f-a5f0-25977f9283b6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-5c60-773f-a5f0-25977f9283b6",
        "storage_key": "property/6767906449166438/019f6c18-5c60-773f-a5f0-25977f9283b6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Xhf9iDtxnRy"
    },
    {
      "id": "custom_60c7b103-8575-4b0f-968f-0ddfba15e39e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f6c18-5c60-773f-a5f0-239a2f3499f6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-5c60-773f-a5f0-239a2f3499f6",
        "storage_key": "property/6767906449166438/019f6c18-5c60-773f-a5f0-239a2f3499f6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BD, 1 BA | 726 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2Y7vo3XfCYr"
    },
    {
      "id": "custom_7d634020-9e17-4bc2-9c8b-7bec9d991a87",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f6c18-5c20-7452-8dee-59f38e7a0f3c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-5c20-7452-8dee-59f38e7a0f3c",
        "storage_key": "property/6767906449166438/019f6c18-5c20-7452-8dee-59f38e7a0f3c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BD, 2 BA | 1048 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=puzftMNxxsn"
    },
    {
      "id": "custom_11b4356f-5adc-45e6-8d3b-629d7ddc6462",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166438/019f6c18-5c20-7452-8dee-56a874ea297b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-5c20-7452-8dee-56a874ea297b",
        "storage_key": "property/6767906449166438/019f6c18-5c20-7452-8dee-56a874ea297b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 3 BD, 2 BA | 1278 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aZ1Apqt9jLe"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfd5-ca52-767d-830b-2c219312586a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-landing-at-fiesta-village-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "in-unit-laundry-mesa-apartments",
      "search_query": "apartments with in-unit laundry mesa az",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Mesa, AZ",
      "h2_subtitle": "Discover the convenience of in-unit laundry in our Mesa, AZ apartments. Enjoy a lifestyle enhanced by amenities tailored to modern living needs.",
      "page_copy": "Experience the perfect blend of convenience and modern living at Landing at Fiesta Village, offering spacious apartments with in-unit laundry in Mesa, AZ. Our community is designed to enhance your everyday lifestyle with thoughtful amenities such as a resident clubhouse with lounge areas, TVs, a coffee bar, and billiards. Whether you're relaxing in the game room or getting work done in the business center, you'll appreciate the seamless blend of comfort and functionality.\n\nEach apartment features a private patio or balcony, allowing you to unwind in the fresh Arizona air. Our gated community with controlled access provides peace of mind, ensuring a safe and serene environment. By choosing our Mesa, AZ apartments, you enjoy the ultimate convenience of in-unit laundry paired with modern amenities that cater to a life of ease and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry | Mesa, AZ",
      "seo_description": "Find Mesa, AZ apartments with in-unit laundry at Landing at Fiesta Village, offering modern amenities in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-maricopa-county",
      "search_query": "pet friendly apartments maricopa county",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Maricopa County",
      "h2_subtitle": "Welcome to pet-friendly living in Maricopa County. Enjoy the convenience and amenities tailored for you and your furry friends.",
      "page_copy": "At Landing at Fiesta Village, we understand the importance of including pets in your home. Our pet-friendly apartments in Maricopa County offer a welcoming environment for you and your furry companions. Enjoy modern amenities such as a resident clubhouse, game room, and business center that cater to a balanced lifestyle.\n\nEach apartment comes with a private patio or balcony, providing extra space for you and your pet to enjoy. Our gated community with controlled access ensures safety and peace of mind. Located in lively Mesa, these apartments allow you to explore pet-friendly Maricopa County with ease, making it an ideal location for pet lovers seeking the perfect home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments | Maricopa County",
      "seo_description": "Discover pet friendly apartments in Maricopa County at Landing at Fiesta Village, complete with modern amenities and a welcoming environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "gourmet-kitchen-apartments-mesa",
      "search_query": "gourmet kitchen apartments in mesa",
      "category": "Amenity",
      "h1_title": "Gourmet Kitchen Apartments in Mesa",
      "h2_subtitle": "Explore Mesa's apartments with gourmet kitchens. Enjoy high-end cooking spaces crafted for culinary excellence, here at Landing at Fiesta Village.",
      "page_copy": "Indulge in culinary delights with our gourmet kitchen apartments located in Mesa at Landing at Fiesta Village. Designed for the passionate home cook, each kitchen offers top-of-the-line features ideal for preparing delicious meals. Complementing these kitchens are spacious layouts and modern amenities like a resident clubhouse, complete with lounge areas and a coffee bar, that enhance the quality of life here.\n\nStep onto your private patio or balcony and savor the fresh Arizona air after a busy day. Feel secure within our gated community with controlled access, offering peace of mind and focused on resident comfort. Our Mesa community is perfect for those seeking a blend of luxury and convenience with a passion for cooking in a well-equipped kitchen.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gourmet Kitchen Apartments | Mesa, AZ",
      "seo_description": "Find Mesa apartments with gourmet kitchens at Landing at Fiesta Village. Enjoy modern amenities and high-end cooking spaces designed for culinary excellence.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "pool-cabanas-apartments-85202",
      "search_query": "apartments with pools and cabanas 85202",
      "category": "Amenity",
      "h1_title": "Apartments with Pools and Cabanas, 85202",
      "h2_subtitle": "Enjoy resort-style living with apartments featuring pools and cabanas in the 85202 area. Make a splash at Landing at Fiesta Village.",
      "page_copy": "Dive into relaxation with our resort-style amenities at Landing at Fiesta Village, where you'll find apartments with pools and cabanas right in the 85202 area. Perfect for those looking to unwind under the Arizona sun, our community offers a refreshing retreat with relaxing poolside cabanas that provide a perfect escape from a busy day.\n\nBesides our splendid pool facilities, residents enjoy access to a host of other amenities, including a vibrant clubhouse with a coffee bar and game room. Each apartment features a private patio or balcony, enhancing the living experience. Nestled within a gated community with controlled access, our apartments offer both luxury and security. Embrace the lifestyle you deserve in 85202.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools and Cabanas | 85202",
      "seo_description": "Discover 85202 apartments with pools and cabanas at Landing at Fiesta Village. Enjoy resort-style amenities and luxurious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "smart-home-apartments-near-fiesta-village",
      "search_query": "smart home apartments near fiesta village",
      "category": "Amenity",
      "h1_title": "Smart Home Apartments Near Fiesta Village",
      "h2_subtitle": "Discover the convenience of smart home living near Fiesta Village. Experience cutting-edge amenities at Landing at Fiesta Village.",
      "page_copy": "Elevate your lifestyle with smart home apartments near Fiesta Village at Landing at Fiesta Village. Our advanced smart home technology integrates seamlessly into modern living, providing enhanced comfort and control. Enjoy the convenience of managing your home environment remotely and effortlessly from your devices.\n\nLocated in the vibrant Mesa community, our apartments offer more than just tech features. Residents benefit from a range of amenities, including a resident clubhouse, game room, and private patios or balconies. Situated in a gated community, residents enjoy security and tranquility. Experience the future of apartment living near Fiesta Village, tailored for those who crave technology and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Apartments | Near Fiesta Village",
      "seo_description": "Explore smart home apartments near Fiesta Village at Landing at Fiesta Village. Enjoy advanced living with modern amenities and smart tech solutions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mesa-az",
      "search_query": "one bedroom apartments mesa az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Mesa, AZ",
      "h2_subtitle": "Discover our one bedroom apartments in Mesa, AZ. Perfectly designed for comfort and convenience at Landing at Fiesta Village.",
      "page_copy": "Find the perfect retreat with our one bedroom apartments in Mesa, AZ, at Landing at Fiesta Village. Offering a harmonious blend of style and practicality, each apartment is thoughtfully designed to meet your living needs. Enjoy spacious interiors complemented by private patios or balconies that provide a tranquil outdoor escape.\n\nOur location in Mesa offers more than just a place to live. Residents enjoy access to first-class amenities such as a well-appointed clubhouse, business center with coworking spaces, and game room. Plus, our gated community provides enhanced security and peace of mind. Immerse yourself in a lifestyle where comfort meets convenience at Landing at Fiesta Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | Mesa, AZ",
      "seo_description": "Explore one bedroom apartments in Mesa, AZ at Landing at Fiesta Village. Enjoy modern living with great amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-maricopa-county",
      "search_query": "two bedroom apartments in maricopa county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Maricopa County at Landing at Fiesta Village. Enjoy premium living with great amenities.",
      "page_copy": "Experience the ideal blend of space and comfort with our two bedroom apartments in Maricopa County, available at Landing at Fiesta Village. Designed to cater to a variety of lifestyles, these spacious homes provide a perfect setting for families, roommates, or individuals needing extra space. Each apartment boasts a private patio or balcony, enhancing your living experience.\n\nEnjoy a wide range of amenities that elevate your lifestyle, from the welcoming clubhouse and game room to the business center equipped with coworking spaces. As a valued resident, you will appreciate the security of living in a gated community with controlled access. Situated in the heart of Maricopa County, our two bedroom apartments offer a serene and well-connected lifestyle at Landing at Fiesta Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments | Maricopa County",
      "seo_description": "Find two bedroom apartments in Maricopa County at Landing at Fiesta Village. Enjoy spacious living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-85202",
      "search_query": "three bedroom apartments near 85202",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 85202",
      "h2_subtitle": "Explore our three bedroom apartments near 85202. Landing at Fiesta Village combines size and luxury for the ideal living space.",
      "page_copy": "Landing at Fiesta Village offers expansive three bedroom apartments near the 85202 area. These larger homes are ideal for families or those seeking extra room for work and play. Each unit features a private patio or balcony, allowing you to enjoy peaceful moments outdoors.\n\nResidents benefit immensely from community amenities, including a resident clubhouse with relaxing lounge areas, a lively game room, and a business center with coworking spaces perfect for remote work. Nestled in a secure, gated community, you will find the perfect blend of lifestyle and convenience at Landing at Fiesta Village. Discover a place where ample space meets modern living near 85202.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments | Near 85202",
      "seo_description": "Discover spacious three bedroom apartments near 85202 at Landing at Fiesta Village. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "apartments-near-arizona-state-university-tempe",
      "search_query": "apartments near arizona state university tempe",
      "category": "School",
      "h1_title": "Apartments Near Arizona State University Tempe",
      "h2_subtitle": "Find your ideal apartment near Arizona State University Tempe. Landing at Fiesta Village offers modern living in a prime location.",
      "page_copy": "Landing at Fiesta Village is the perfect choice for those seeking apartments near Arizona State University Tempe. Situated conveniently close, our community offers students and professionals a compelling mix of modern amenities and practical living. With a variety of floor plans, each apartment features private patios or balconies and is designed to offer a comfortable living space.\n\nResidents can enjoy a host of amenities including a vibrant clubhouse complete with lounge areas and a game room, alongside a business center featuring coworking spaces for study or work. The gated community ensures added security and peace of mind. Discover modern apartment living with easy access to academic and social hubs at Landing at Fiesta Village, just a short drive from ASU Tempe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near ASU Tempe",
      "seo_description": "Explore apartments near Arizona State University Tempe at Landing at Fiesta Village. Enjoy modern amenities in a secure community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "apartments-close-to-mesa-community-college",
      "search_query": "apartments close to mesa community college maricopa county",
      "category": "School",
      "h1_title": "Apartments Close to Mesa Community College",
      "h2_subtitle": "Discover convenient apartments close to Mesa Community College in Maricopa County. Enjoy easy commutes and comfortable living.",
      "page_copy": "Located near Mesa Community College, Landing at Fiesta Village offers the ideal setting for students, faculty, and staff looking for comfortable apartments in Maricopa County. Our range of well-designed apartment homes includes private patios or balconies, providing a perfect spot for relaxation after a long day.\n\nAs a resident, you can enjoy a wealth of community amenities. Engage in leisure activities at our resident clubhouse or challenge friends in our game room. The business center with coworking spaces caters to those balancing both leisure and learning. With controlled access throughout our gated community, you can feel secure while enjoying the many advantages of living close to Mesa Community College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to MCC | Maricopa County",
      "seo_description": "Find apartments close to Mesa Community College at Landing at Fiesta Village. Experience convenient living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "apartments-near-banner-desert-medical-center",
      "search_query": "apartments near Banner Desert Medical Center Mesa",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner Desert Medical Center Mesa",
      "h2_subtitle": "Explore comfortable apartments near Banner Desert Medical Center in Mesa. Landing at Fiesta Village offers an ideal location for healthcare professionals.",
      "page_copy": "Landing at Fiesta Village is perfectly situated for those seeking apartments near Banner Desert Medical Center in Mesa. Whether you are a healthcare professional or visiting family, our community provides convenient access and modern living options. Each apartment boasts a private patio or balcony, ideal for unwinding.\n\nEnjoy the convenience of a gated community with controlled access, ensuring safety and peace of mind. Our resident clubhouse with lounge areas, game room, and a business center with coworking spaces provides an excellent blend of relaxation and productivity. Choose Landing at Fiesta Village for comfort and convenience near Banner Desert Medical Center in Mesa.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner Desert Medical Center",
      "seo_description": "Find comfortable, convenient apartments near Banner Desert Medical Center at Landing at Fiesta Village. Perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "apartment-rentals-close-to-banner-children",
      "search_query": "apartment rentals close to Banner Children's at Desert 85202",
      "category": "Hospital",
      "h1_title": "Apartment Rentals Close to Banner Children's 85202",
      "h2_subtitle": "Discover apartment rentals close to Banner Children's at Desert in Mesa 85202. Convenient living for families and healthcare workers awaits.",
      "page_copy": "Landing at Fiesta Village offers ideal apartment rentals close to Banner Children's at Desert in the 85202 area code. Perfect for healthcare professionals and families, our community combines prime location and exceptional amenities. Apartments feature private patios or balconies, providing a personal retreat after busy days.\n\nEnjoy access to a variety of community amenities, including a resident clubhouse equipped with TVs and a coffee bar, along with a well-appointed game room. The business center offers coworking spaces, ideal for remote work or study. Our gated community in Mesa ensures security and peace of mind, making it an excellent choice for those working at or visiting Banner Children's.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals Near Banner Children's 85202",
      "seo_description": "Find apartment rentals close to Banner Children's at Desert in Mesa's 85202. Perfect for healthcare workers and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "apartments-near-tempe-beach-park",
      "search_query": "apartments near Tempe Beach Park AZ",
      "category": "Park",
      "h1_title": "Apartments Near Tempe Beach Park, AZ",
      "h2_subtitle": "Experience vibrant living near Tempe Beach Park in AZ. Discover spacious apartments with exceptional amenities at Landing at Fiesta Village.",
      "page_copy": "Landing at Fiesta Village offers apartments conveniently located near Tempe Beach Park, AZ. Just a short drive away, enjoy easy access to park adventures and vibrant community events. Whether you're looking to relax or explore, our location makes it all possible.\n\nOur modern apartments feature private patios or balconies, perfect for enjoying the Arizona climate. Residents can take advantage of our clubhouse with lounge areas, game room, and a business center with coworking spaces. As a gated community with controlled access, we provide a secure and welcoming environment near Tempe Beach Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tempe Beach Park, AZ",
      "seo_description": "Find spacious apartments near Tempe Beach Park, offering vibrant living and exceptional amenities at Landing at Fiesta Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "landing-freestone-district-park-neighborhood",
      "search_query": "landing at Freestone District Park neighborhood",
      "category": "Park",
      "h1_title": "Landing at Freestone District Park Neighborhood",
      "h2_subtitle": "Discover the community around Landing at Fiesta Village near Freestone District Park. Enjoy modern living with nearby recreational options in Mesa.",
      "page_copy": "Situated near the inviting Freestone District Park neighborhood, Landing at Fiesta Village offers the perfect blend of modern living and recreation. Our community is a haven for those who appreciate proximity to open green spaces, ensuring easy access to walking trails and leisure activities.\n\nEach apartment is designed with comfort in mind, featuring amenities like a private patio or balcony. Our community impresses with a resident clubhouse, complete with TVs and a coffee bar, as well as a game room and business center. For those valuing security, our gated community offers controlled access, making it an ideal choice near Freestone District Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Landing at Freestone District Park Area",
      "seo_description": "Experience modern living near Freestone District Park at Landing at Fiesta Village in Mesa, with unmatched community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "riverview-park-maricopa-county-apartment-living",
      "search_query": "Riverview Park Maricopa County apartment living",
      "category": "Park",
      "h1_title": "Riverview Park Maricopa Apartment Living",
      "h2_subtitle": "Explore unparalleled apartment living near Riverview Park in Maricopa County. Enjoy convenience and community at Landing at Fiesta Village.",
      "page_copy": "Landing at Fiesta Village offers a unique apartment living experience near Riverview Park in Maricopa County. Located amidst the lush landscapes and recreational offerings of the park, our community provides the perfect setting for both relaxation and adventure. Residents enjoy convenient access to outdoor activities while residing in a vibrant, comfortable community.\n\nOur gated community boasts amenities like a resident clubhouse, complete with a coffee bar and game room, ideal for socializing. Private patios or balconies offer a personal retreat, while our business center caters to professional needs. For those seeking a modern lifestyle with the allure of Riverview Park nearby, Landing at Fiesta Village is the ideal choice.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Riverview Park Maricopa Apartment Living",
      "seo_description": "Discover apartment living near Riverview Park, Maricopa County. Enjoy modern amenities at Landing at Fiesta Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "apartments-near-veterans-way-college-ave-mesa",
      "search_query": "apartments near Veterans Way/College Ave in Mesa",
      "category": "Transit",
      "h1_title": "Apartments Near Veterans Way/College Ave, Mesa",
      "h2_subtitle": "Find your ideal home near Veterans Way/College Ave in Mesa. Discover comfort and convenience at Landing at Fiesta Village.",
      "page_copy": "Welcome to Landing at Fiesta Village, where you’ll find ideal apartments near Veterans Way/College Ave in Mesa. Our prime location ensures you're never far from vibrant city life, including local shops, dining, and cultural landmarks. Living here means enjoying both the convenience of proximity and the tranquility of a community-focused environment.\n\nOur gated community offers a host of amenities designed for modern living. From the resident clubhouse with a relaxing coffee bar and game room to private patios or balconies, we provide the perfect balance of comfort and style. With a business center available for professionals and controlled access for added security, Landing at Fiesta Village stands out as a premier living choice near Veterans Way/College Ave.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Veterans Way/College Ave, Mesa",
      "seo_description": "Discover comfortable and convenient living near Veterans Way/College Ave in Mesa at Landing at Fiesta Village, equipped with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "gilbert-rd-main-st-transit-apartments-85202",
      "search_query": "Gilbert Rd. / Main St. transit apartments 85202",
      "category": "Transit",
      "h1_title": "Gilbert Rd/Main St Transit Apartments in 85202",
      "h2_subtitle": "Explore transit-friendly apartments near Gilbert Rd/Main St in the 85202 area. Enjoy a thriving community at Landing at Fiesta Village.",
      "page_copy": "Landing at Fiesta Village offers transit-friendly apartments located near Gilbert Rd and Main St in the 85202 zip code area. Our community is perfect for those who value easy access to public transit, allowing for seamless travel throughout Mesa and beyond. The strategic location benefits commuters and anyone seeking quick connectivity.\n\nBeyond location, enjoy living in style with private patios or balconies and access to a full range of amenities. Join neighbors in our resident clubhouse, or relax in the game room and lounge areas. With a gated environment providing controlled access, residents can enjoy peace of mind and comfort at Landing at Fiesta Village, situated conveniently near Gilbert Rd/Main St.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gilbert Rd/Main St Transit Apartments 85202",
      "seo_description": "Discover transit-friendly living at Landing at Fiesta Village near Gilbert Rd/Main St in the 85202 area. Spacious apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "mill-ave-3rd-st-proximity-apartments-maricopa-county",
      "search_query": "Mill Ave/3rd St proximity apartments Maricopa County",
      "category": "Transit",
      "h1_title": "Proximity Apartments Near Mill Ave/3rd St",
      "h2_subtitle": "Discover apartments near Mill Ave/3rd St in Maricopa County. Experience the blend of urban convenience and community living at Landing at Fiesta Village.",
      "page_copy": "Experience the dynamic lifestyle of proximity apartments near Mill Ave/3rd St in Maricopa County with Landing at Fiesta Village. Our location provides easy access to the vibrant social and cultural scenes, all within a short distance from the heart of Mesa. This ideal setting ensures that work, entertainment, and daily tasks are mere moments away.\n\nAt Landing at Fiesta Village, residents enjoy a perfect blend of comfort and modern amenities. Our gated community features a business center for professionals and numerous leisure options including a clubhouse with a coffee bar and game room. Enjoy serenity and convenience with private patios or balconies, making this the perfect choice for anyone seeking a connected lifestyle in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Mill Ave/3rd St Maricopa County",
      "seo_description": "Find your ideal home at Landing at Fiesta Village near Mill Ave/3rd St. Enjoy modern amenities and a vibrant community in Maricopa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "dorsey-ln-apache-blvd-accessible-apartments",
      "search_query": "Dorsey Ln/Apache Blvd accessible apartments",
      "category": "Transit",
      "h1_title": "Accessible Apartments Near Dorsey Ln/Apache Blvd",
      "h2_subtitle": "Discover the perfect accessible apartment at Landing at Fiesta Village near Dorsey Ln/Apache Blvd. Enjoy convenience and comfort in Mesa.",
      "page_copy": "Welcome to Landing at Fiesta Village, where you’ll find accessible apartments near Dorsey Ln and Apache Blvd. Our community is ideally positioned to provide easy access to public transit, major roads, and local amenities, making it an excellent choice for individuals seeking convenience and connectivity in Mesa.\n\nOur gated community offers a wide range of modern amenities tailored for comfort and style. Relax at the resident clubhouse with lounge areas and a vibrant coffee bar, or enjoy some leisure time in the game room. For added convenience, our business center and coworking spaces are perfect for remote working. Experience the ideal blend of accessibility, comfort, and community at Landing at Fiesta Village near Dorsey Ln/Apache Blvd.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apartments Near Dorsey Ln/Apache Blvd",
      "seo_description": "Find accessible apartments at Landing at Fiesta Village near Dorsey Ln/Apache Blvd. Enjoy community and convenience in Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166438",
      "source": "generator",
      "page_item_url": "mcclintock-apache-blvd-apartments-mesa-az",
      "search_query": "McClintock/Apache Blvd apartments in Mesa AZ",
      "category": "Transit",
      "h1_title": "Apartments Near McClintock/Apache Blvd, Mesa AZ",
      "h2_subtitle": "Explore ideal living near McClintock and Apache Blvd in Mesa, AZ. Find your new home at Landing at Fiesta Village, where comfort meets convenience.",
      "page_copy": "Situated near McClintock and Apache Blvd in Mesa, AZ, Landing at Fiesta Village offers vibrant apartment living tailored for those who crave convenience and connectivity. This strategic location ensures that you're just moments away from major attractions, dining, and shopping destinations throughout the Mesa area.\n\nOur community is designed with modern lifestyles in mind, providing spacious apartments and exclusive amenities. Enjoy unwinding in our resident clubhouse, complete with TVs, a coffee bar, and billiards, or make use of our game room. Each apartment features a private patio or balcony, creating your personal retreat within this bustling area. Experience the perfect home base at our McClintock/Apache Blvd apartments in Mesa, AZ.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McClintock/Apache Blvd, Mesa AZ",
      "seo_description": "Find comfort and connectivity at Landing at Fiesta Village near McClintock/Apache Blvd. Enjoy top amenities and vibrant living in Mesa, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5308"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425613"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N5QF25DL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "912LFV"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('gXE3EAfgIfXSeu3fL5')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40264928050"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Landing at Fiesta Village/scheduletourwidget/uUUv7rJpkPZmwntN5T/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImFvS2lBMzk1V2FqQWVrSXVXRWFTMXc9PSIsInZhbHVlIjoiL2FMY3VGNWtZbHdwSEJ6SitJbm5FUT09IiwibWFjIjoiMWViYTZlNDI1OWRiYmVkZjRjN2NiZGZiYzc5YjMyZjliYzlmM2Q0NjMxOWJiODU1NzhiOGJhMjRmY2IzYjhiNSJ9"
    }
  ],
  "custom_qb_id": "5308",
  "custom_repli_id": "18104425613",
  "custom_google_gtm_id": "GTM-N5QF25DL",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "912LFV",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('gXE3EAfgIfXSeu3fL5')</script>",
  "custom_hubspot_company_id": "40264928050",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Landing at Fiesta Village/scheduletourwidget/uUUv7rJpkPZmwntN5T/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImFvS2lBMzk1V2FqQWVrSXVXRWFTMXc9PSIsInZhbHVlIjoiL2FMY3VGNWtZbHdwSEJ6SitJbm5FUT09IiwibWFjIjoiMWViYTZlNDI1OWRiYmVkZjRjN2NiZGZiYzc5YjMyZjliYzlmM2Q0NjMxOWJiODU1NzhiOGJhMjRmY2IzYjhiNSJ9",
  "custom_audioeye_site_id": "91c08ef4-14c2-4aa0-8360-7543a54be684",
  "custom_audioeye_site_hash": "70c27f1516918c6b09a9d29ffc90a07b"
};

export const generatedAt = '2026-08-21T22:00:29.616Z';
